import { TelescopeIcon } from 'src/components/icons/telescope'
import { Colors } from 'src/components/theme'
import { ResultItem } from 'src/v2/components/sidebar-result-list'

export const EmptyResultItem = (props: { title?: string }) => {
  return (
    <ResultItem
      disabled
      item={{
        color: Colors.neutral100,
        icon: <TelescopeIcon size={16} color={Colors.neutral600} />,
        title: '',
        subtitle: props.title ? `No ${props.title} results found.` : 'No results found.',
        id: 'no-results-found',
      }}
    />
  )
}
